import HomeTemplate from '~templates/home'
export default HomeTemplate